const normalizeResources = (resources) =>
  resources.map(r => ({
    ...r.attributes,
    guid: r.guid,
    type: r.type
  }));

const normalizeTaskResponseResources = (resources) =>
  resources.map(r => ({
    ...r.attributes,
    guid: r.guid,
    type: r.type,
    task: r.task
  }));

const normalizeResource = (resource) => ({
    ...resource.attributes,
    guid: resource.guid,
    type: resource.type
  })

const formatDate = (date) => {
  let d = new Date(date);
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
};

const addWeeksToDate = (dateObj,numberOfWeeks) => {
  dateObj.setDate(dateObj.getDate()+ numberOfWeeks * 7);
  return dateObj;
}

function datediff(first, second) {
  return Math.round((second - first) / (1000 * 60 * 60 * 24));
}

function taskDelay(ms) {
  return new Promise(res => {
    setTimeout(() => res(),ms)
  })
}

function export2Word(element, filename = ''){
  let preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
  let postHtml = "</body></html>";
  let html = preHtml+document.getElementById(element).innerHTML+postHtml;

  let blob = new Blob(['\ufeff', html], {
    type: 'application/msword'
  });

  // Specify link url
  let url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);

  // Specify file name
  filename = filename?filename+'.doc':'document.doc';

  // Create download link element
  let downloadLink = document.createElement("a");

  document.body.appendChild(downloadLink);

  if(navigator.msSaveOrOpenBlob ){
    navigator.msSaveOrOpenBlob(blob, filename);
  }else{
    // Create a link to the file
    downloadLink.href = url;

    // Setting the file name
    downloadLink.download = filename;

    //triggering the function
    downloadLink.click();
  }

  document.body.removeChild(downloadLink);
}

export {
  normalizeResources,
  normalizeTaskResponseResources,
  normalizeResource,
  formatDate,
  addWeeksToDate,
  datediff,
  taskDelay,
  export2Word
}
